import React, {useState, useEffect} from "react";
import {AutoComplete} from "primereact/autocomplete";
import RemotingService from "../../../../../services/remoting-service/RemotingService";

export default function LabCptSelector({type, value, disabled, placeholder, onChange}) {
    const [suggestions, setSuggestions] = useState([]);
    const [selectedCpt, setSelectedCpt] = useState(value || null);

    useEffect(() => {
        setSelectedCpt(value);
    }, [value]);

    const searchCpt = (event) => {
        if (!type || event.query.length < 2) {
            return;
        }

        RemotingService.getRemoteCall(`api/lab-cpt/search/${type}`, {
            query: event.query
        }, (results) => {
            setSuggestions(results.map(r => ({
                ...r,
                label: `${r.cptCode} - ${r.description}`
            })));
        });
    };

    const handleSelect = (event) => {
        setSelectedCpt(event.value);
        if (onChange) {
            onChange(event.value);
        }
    };

    const handleClear = () => {
        setSelectedCpt(null);
        if (onChange) {
            onChange(null);
        }
    };

    return (
        <div style={{position: 'relative'}}>
            <AutoComplete
                placeholder={placeholder || "Search by name or code..."}
                field="label"
                value={selectedCpt}
                disabled={disabled || !type}
                onChange={(event) => {
                    if (typeof event.value === 'string') {
                        return;
                    }
                    setSelectedCpt(event.value);
                }}
                onSelect={handleSelect}
                onClear={handleClear}
                suggestions={suggestions}
                completeMethod={searchCpt}
                itemTemplate={(cpt) => (
                    <span>{cpt.cptCode} - {cpt.description}</span>
                )}
                selectedItemTemplate={(cpt) => (
                    cpt ? `${cpt.cptCode} - ${cpt.description}` : ''
                )}
                dropdown={false}
                style={{width: '100%'}}
                inputStyle={{width: '100%'}}
            />
        </div>
    );
}
